const navbar = {
  packages: "套餐", // translated
  hotelPackages: "酒店套餐", // translated
  experiences: "经验", // translated
  close: "关闭", // translated
  hotDeals: "热卖", // translated
  dashboard: "仪表板", // translated
  pricing: "价钱", // translated
};


export default navbar;
